<div class="cursor-hooks-download" *ngIf="hasEnrollmentKey">
  <div class="hooks-section-title">
    {{ 'integrationPage.cursorHooks.title' | labelsProvider }}
  </div>
  <div class="hooks-description">
    {{ 'integrationPage.cursorHooks.description' | labelsProvider }}
  </div>

  <div class="os-selection">
    <span class="os-label">
      {{ 'integrationPage.cursorHooks.osSelection' | labelsProvider }}:
    </span>
    <div class="os-toggle">
      <button
        type="button"
        class="os-toggle-button"
        [class.active]="selectedOs() === 'macLinux'"
        (click)="selectOs('macLinux')"
      >
        {{ 'integrationPage.cursorHooks.macLinux' | labelsProvider }}
      </button>
      <button
        type="button"
        class="os-toggle-button"
        [class.active]="selectedOs() === 'windows'"
        (click)="selectOs('windows')"
      >
        {{ 'integrationPage.cursorHooks.windows' | labelsProvider }}
      </button>
    </div>
  </div>

  <div class="hooks-buttons">
    <button
      *ngFor="let hook of hooks"
      type="button"
      class="hook-download-button"
      (click)="downloadHook(hook)"
    >
      <i class="pi pi-download"></i>
      <span>{{ hook }}</span>
    </button>
  </div>

  <button type="button" class="download-all-button" (click)="downloadAllHooks()">
    <i class="pi pi-download"></i>
    <span>{{ 'integrationPage.cursorHooks.downloadAll' | labelsProvider }}</span>
  </button>

</div>
